import React from "react" ;

/**
 * Specification of props for the arc drawer
 */
export type CanvasThrobberArcProps = {
    /**
     * The x-coordinate of the center of the shape
     */
    x: number;

    /**
     * The y-coordinate of the center of the shape
     */
    y: number;

    /**
     * The radius of the ellipse on the x-axis
     */
    radiusX: number;

    /**
     * The radius of the ellipse on the y-axis
     */
    radiusY: number;

    /**
     * The width of the stroke, defined in vPX
     */
    w?: number;

    /**
     * A delay before the rendering of the rectangle begins, defined in percent
     * of the total drawing.
     */
    delay?: number;

    /**
     * The duration of the drawing of the rectangle, defined in percent of the
     * total drawing duration.
     */
    duration: number;

    /**
     * If you want multiple shapes to use the same easing-curve, then make sure
     * that they are given the same ease-name. This is useful if for instance
     * you are drawing two shapes that are part of the same visual entity.
     */
    ease?: string;
};

/**
 * This component is used to configure drawing of an arc inside a
 * [[CanvasThrobber]].
 */
// tslint:disable-next-line variable-name
export const CanvasThrobberArc: React.FC<CanvasThrobberArcProps> = () => null;

/**
 * Type specification of the arc, so that we can safely identify it even if
 * react-hot-loader was used.
 */
export const typeOfCanvasThrobberArc = (<CanvasThrobberArc x={0} y={0} radiusX={0} radiusY={0} duration={0} />).type;
